var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_vm._v("\n  This page does not exist. "),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Go back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }